/**
 * NavPrimary
 *
 * @module components/Nav/NavPrimary
 */

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';

import NavHorizontal from '../../components/lib/NavHorizontal/NavHorizontal';
import { AriaRoles } from '../../constants/AccessibilityConstants';
import { messages as m } from '../../constants/Nav';
import {
  getCollectionPath,
  isBrowsePath,
  isCollectionPath,
  isPathInNowPlayingPath,
} from '../../lib/RouteUtils';

import NavHistoryButtons from './NavHistoryButtons';

import './NavPrimary.scss';

export class NavPrimary extends React.Component {
  static propTypes = {
    pathname: PropTypes.string.isRequired,
    currentMyCollectionPath: PropTypes.string,
    nowPlayingPath: PropTypes.string,
    browsePath: PropTypes.string,
    isDark: PropTypes.bool.isRequired,
    updateSearchOverlay: PropTypes.func,
    qaTagNowPlaying: PropTypes.string,
    qaTagMyStations: PropTypes.string,
    qaTagMyMusic: PropTypes.string,
    router: PropTypes.object.isRequired,
    isCollectionEmpty: PropTypes.bool,
    hasCurrentTrack: PropTypes.bool,
  };

  onLinkClicked = link => {
    this.props.router.push(link);
    if (this.props.updateSearchOverlay) {
      this.props.updateSearchOverlay();
    }
  };

  render() {
    const links = [
      {
        label: <FormattedMessage {...m.nowPlaying} />,
        url: this.props.nowPlayingPath,
        isActive: isPathInNowPlayingPath(this.props.pathname),
        qaTag: this.props.qaTagNowPlaying,
        isDisabled: !this.props.hasCurrentTrack,
      },
      {
        label: <FormattedMessage {...m.myCollection} />,
        url: this.props.currentMyCollectionPath || getCollectionPath(),
        isActive: isCollectionPath(this.props.pathname),
        qaTag: this.props.qaTagMyStations,
      },
      {
        label: <FormattedMessage {...m.browse} />,
        url: this.props.browsePath,
        isActive: isBrowsePath(this.props.pathname),
      },
    ];

    return (
      <nav className='NavPrimary' role={AriaRoles.NAVIGATION}>
        <NavHistoryButtons isBackgroundDark={this.props.isDark} />
        <NavHorizontal
          links={links}
          isBackgroundDark={this.props.isDark}
          onLinkClicked={this.onLinkClicked}
        />
      </nav>
    );
  }
}

export default withRouter(NavPrimary);
